/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
//import Analytics from "layouts/dashboards/analytics";
//import Sales from "layouts/dashboards/sales";
//import ProfileOverview from "layouts/pages/profile/profile-overview";
// import AllProjects from "layouts/pages/profile/all-projects";
// import NewUser from "layouts/pages/users/new-user";
//import Settings from "layouts/pages/account/settings";
// import Billing from "layouts/pages/account/billing";
// import Invoice from "layouts/pages/account/invoice";
// import Timeline from "layouts/pages/projects/timeline";
// import PricingPage from "layouts/pages/pricing-page";
// import Widgets from "layouts/pages/widgets";
// import RTL from "layouts/pages/rtl";
// import Charts from "layouts/pages/charts";
// import Notifications from "layouts/pages/notifications";
// import Kanban from "layouts/applications/kanban";
// import Wizard from "layouts/applications/wizard";
// import DataTables from "layouts/applications/data-tables";
// import Calendar from "layouts/applications/calendar";
// import NewProduct from "layouts/ecommerce/products/new-product";
// import EditProduct from "layouts/ecommerce/products/edit-product";
// import ProductPage from "layouts/ecommerce/products/product-page";
// import OrderList from "layouts/ecommerce/orders/order-list";
// import OrderDetails from "layouts/ecommerce/orders/order-details";
import SignInBasic from "layouts/authentication/sign-in/basic";
/*import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpCover from "layouts/authentication/sign-up/cover";
import ResetCover from "layouts/authentication/reset-password/cover";*/

// Material Dashboard 2 PRO React components
//import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
//import profilePicture from "assets/images/team-3.jpg";
// import CustomerManagement from "layouts/pages/setup/customer-mgmt";
// import UserManagement from "layouts/pages/setup/user-mgmt";

// Warehouse
import WarehouseList from "layouts/views/setup/warehouse-mgmt";
import AddWarehouse from "layouts/views/setup/warehouse-mgmt/add-warehouse";
import EditWarehouse from "layouts/views/setup/warehouse-mgmt/edit-warehouse";
// Zone
import ZoneList from "layouts/views/setup/zone-mgmt";
import AddZone from "layouts/views/setup/zone-mgmt/add-zone";
import EditZone from "layouts/views/setup/zone-mgmt/edit-zone";
import UploadZone from "layouts/views/setup/zone-mgmt/upload-zone";
// Company
import CompanyList from "layouts/views/setup/company-mgmt";
import AddCompany from "layouts/views/setup/company-mgmt/add-company";
import EditCompany from "layouts/views/setup/company-mgmt/edit-company";
// Location
import LocationList from "layouts/views/setup/location-mgmt";
import AddLocation from "layouts/views/setup/location-mgmt/add-location";
import EditLocation from "layouts/views/setup/location-mgmt/edit-location";
import UploadLocation from "layouts/views/setup/location-mgmt/upload-location";
// Vendor
import VendorList from "layouts/views/setup/vendor-mgmt";
import AddVendor from "layouts/views/setup/vendor-mgmt/add-vendor";
import EditVendor from "layouts/views/setup/vendor-mgmt/edit-vendor";
// SKU
import UploadSKU from "layouts/views/setup/sku-mgmt/upload-sku";
import UploadSKUPackTypeWeight from "layouts/views/setup/sku-mgmt/upload-sku-packtype-weight";
// UOM
import UOMList from "layouts/views/setup/uom-mgmt";
import AddUOM from "layouts/views/setup/uom-mgmt/add-uom";
import EditUOM from "layouts/views/setup/uom-mgmt/edit-uom";
// Carrier
import CarrierList from "layouts/views/setup/carrier-mgmt";
import AddCarrier from "layouts/views/setup/carrier-mgmt/add-carrier";
import EditCarrier from "layouts/views/setup/carrier-mgmt/edit-carrier";
// Consignee
import ConsigneeList from "layouts/views/setup/consignee-mgmt";
import AddConsignee from "layouts/views/setup/consignee-mgmt/add-consignee";
import EditConsignee from "layouts/views/setup/consignee-mgmt/edit-consignee";
import UploadConsignee from "layouts/views/setup/consignee-mgmt/upload-consignee";
// Customer
import CustomerList from "layouts/views/setup/customer-mgmt";
import AddCustomer from "layouts/views/setup/customer-mgmt/add-customer";
import EditCustomer from "layouts/views/setup/customer-mgmt/edit-customer";
import AddCustCarrier2 from "layouts/views/setup/cust-carrier-mgmt/add-cust-carrier2";
// Vendor SKU
import AddVendorSKU from "layouts/views/setup/vendor-sku-mgmt/add-vendor-sku";
import EditVendorSKU from "layouts/views/setup/vendor-sku-mgmt/edit-vendor-sku";
import AddSKURetailBarcode from "layouts/views/setup/sku-retail-barcode-mgmt/add-sku-retail-barcode";
// SKU Pack Type
import AddSKUPackType from "layouts/views/setup/sku-pack-type-mgmt/add-sku-pack-type";
import EditSKUPackType from "layouts/views/setup/sku-pack-type-mgmt/edit-sku-pack-type";
// Shipping Zone
import ShippingZoneList from "layouts/views/setup/shipping-zone-mgmt";
import AddShippingZone from "layouts/views/setup/shipping-zone-mgmt/add-shipping-zone";
import EditShippingZone from "layouts/views/setup/shipping-zone-mgmt/edit-shipping-zone";
// Preferred Location
import PreferredLocationList from "layouts/views/setup/preferred-location-mgmt/list";
import NewPreferredLocation from "layouts/views/setup/preferred-location-mgmt/add-preferred-location";
import EditPreferredLocation from "layouts/views/setup/preferred-location-mgmt/edit-preferred-location-sku";
import UploadPreferredLocation from "layouts/views/setup/preferred-location-mgmt/upload-preferred-location";
import NewPickFaceLocation from "layouts/views/setup/pickface-location-mgmt/add-pickface-location";
import UploadPickFaceLocation from "layouts/views/setup/pickface-location-mgmt/upload-pickface-location";

import NewTeamRole from "layouts/views/setup/team-role-mgmt/add-team-role";
import TeamRoleList from "layouts/views/setup/team-role-mgmt";
import EditTeamRole from "layouts/views/setup/team-role-mgmt/edit-team-role";

// PO
import POList from "layouts/views/inbound/purchase-order";
import AddPO from "layouts/views/inbound/purchase-order/add-po";
import EditPO from "layouts/views/inbound/purchase-order/edit-po";
import UploadPO from "layouts/views/inbound/purchase-order/upload-po";
// ASN
import ASNList from "layouts/views/inbound/asn";
import AddASN from "layouts/views/inbound/asn/add-asn";
import EditASN from "layouts/views/inbound/asn/edit-asn";
// PO Recv
import PORecvList from "layouts/views/inbound/po-receiving";
import AddPOReceiving from "layouts/views/inbound/po-receiving/add-po-receiving";
import EditPOReceiving from "layouts/views/inbound/po-receiving/edit-po-receiving";
// CO
import COList from "layouts/views/inbound/collection-order";
import AddCO from "layouts/views/inbound/collection-order/add-co";
import EditCO from "layouts/views/inbound/collection-order/edit-co";
// CO Recv
import CORecvList from "layouts/views/inbound/co-receiving";
import AddCOReceiving from "layouts/views/inbound/co-receiving/add-co-receiving";
import EditCOReceiving from "layouts/views/inbound/co-receiving/edit-co-receiving";
// Recv
import RecvList from "layouts/views/inbound/receiving";
import AddReceiving from "layouts/views/inbound/receiving/add-receiving";
import EditReceiving from "layouts/views/inbound/receiving/edit-receiving";
import PutawayList from "layouts/views/inbound/putaway";
import EditPutaway from "layouts/views/inbound/putaway/edit-putaway";
import AddSKU2 from "layouts/views/setup/sku-mgmt/add-sku2";
import EditSKU2 from "layouts/views/setup/sku-mgmt/edit-sku2";
import VendorSKUList from "layouts/views/setup/vendor-sku-mgmt/index2";
import SKUPackTypeList from "layouts/views/setup/sku-pack-type-mgmt/index2";
import PickFaceLocationList from "layouts/views/setup/pickface-location-mgmt";
import RemovePickFaceLocation from "layouts/views/setup/pickface-location-mgmt/remove-pickface-location-sku";

import AdjustmentReasonList from "layouts/views/setup/adjustment-reason-mgmt";
import AddAdjustmentReason from "layouts/views/setup/adjustment-reason-mgmt/add-adjustment-reason";
import EditAdjustmentReason from "layouts/views/setup/adjustment-reason-mgmt/edit-adjustment-reason";

import AddAdjustment from "layouts/views/setup/adjustment-mgmt/add-adjustment";
import AdjustmentList from "layouts/views/setup/adjustment-mgmt";

import StockHoldList from "layouts/views/setup/stock-hold-mgmt";
import AddStockHold from "layouts/views/setup/stock-hold-mgmt/add-stock-hold";

import AddSO from "layouts/views/outbound/sales-order/add-so";
import SOList from "layouts/views/outbound/sales-order";
import EditSO from "layouts/views/outbound/sales-order/edit-so";
import UploadSO from "layouts/views/outbound/sales-order/upload-so";

import DOList from "layouts/views/outbound/delivery-order";
import EditDO from "layouts/views/outbound/delivery-order/edit-do";
import TaskAssignmentList from "layouts/views/setup/task-assignment-mgmt";
import ManifestList from "layouts/views/outbound/load-manifest";
import AddLoadManifest from "layouts/views/outbound/load-manifest/add-load-manifest";
import EditLoadManifest from "layouts/views/outbound/load-manifest/edit-load-manifest";
import ProofOfDelivery from "layouts/views/outbound/proof-of-delivery";
// import TestLayout from "test/TestLayout";
import InventoryList from "layouts/views/inventory/inventory-mgmt";
import InventoryList2 from "layouts/views/inventory/index2";
import SKUList from "layouts/views/setup/sku-mgmt/list";
import InventoryLocationList from "layouts/views/inventory/location-list";
import InventorySKUDetails from "layouts/views/inventory/sku-details";
import AddKitSKU from "layouts/views/setup/kit-sku-mgmt/add-kit-sku";
import EditKitSKU from "layouts/views/setup/kit-sku-mgmt/edit-kit-sku";
import UploadSKUKit from "layouts/views/setup/sku-mgmt/upload-sku-kit";
import TaskList from "layouts/views/outbound/task-list";

import EditStockAttributes from "layouts/views/inventory/stock-attributes-mgmt/edit-stock-attributes";
import StockAttributesList from "layouts/views/inventory/stock-attributes-mgmt";
import AddCustomerWarehouseSetting2 from "layouts/views/setup/cust-wh-setting-mgmt/add-cust-wh-setting2";
import GeneratePhysicalCount from "layouts/views/inventory/physical-count-mgmt";
import AddAPISetting from "layouts/views/setup/api-setting-mgmt/add-api-setting";
import GenerateCycleCount from "layouts/views/inventory/cycle-count-mgmt";
import MISCReport from "layouts/views/report/MISC";
import COReport from "layouts/views/report/collection-order";
import POReport from "layouts/views/report/purchase-order";
import PickslipReport from "layouts/views/report/pickslip";
import PutawayReport from "layouts/views/report/putaway";
import DeliveryOrderReport from "layouts/views/report/delivery-order";
import AddStockTransfer from "layouts/views/inventory/stock-transfer-mgmt/add-stock-transfer";
import StockTransferList from "layouts/views/inventory/stock-transfer-mgmt";
import ESOList from "layouts/views/outbound/eso";

import UpdatePhysicalCount from "layouts/views/inventory/physical-count-mgmt/update";
import UpdateCycleCount from "layouts/views/inventory/cycle-count-mgmt/update";
import UpdateReplenishment from "layouts/views/inventory/replenishment-mgmt/update";
import SKUMovementEnquiry from "layouts/views/enquiry/sku-movement";
import SKUMovementSummaryEnquiry from "layouts/views/enquiry/sku-movement-summary";
import StockInventoryEnquiry from "layouts/views/enquiry/stock-inventory";
import OrderDetailsStatusEnquiry from "layouts/views/enquiry/order-details-status";
import AgingReportEnquiry from "layouts/views/enquiry/aging-report";
import POReceivingEnquiry from "layouts/views/enquiry/po-receiving";
import ShelfLifeReportEnquiry from "layouts/views/enquiry/shelf-life-report";
import AdjustmentEnquiry from "layouts/views/enquiry/adjustment";
import TransferEnquiry from "layouts/views/enquiry/transfer";
import PickslipEnquiry from "layouts/views/enquiry/pickslip";
import GRNReportEnquiry from "layouts/views/enquiry/grn-report";
import PhysicalCountEnquiry from "layouts/views/enquiry/physical-count";
import CycleCountEnquiry from "layouts/views/enquiry/cycle-count";
import AddStockUnhold from "layouts/views/setup/stock-hold-mgmt/add-stock-unhold";
import OpeningBalance from "layouts/views/inventory/opening-balance-mgmt";
import AddNewReplenishment from "layouts/views/inventory/replenishment-mgmt";
import PODashboard from "layouts/views/dashboards/receiving";
import CODashboard from "layouts/views/dashboards/receiving/co";
import MiscDashboard from "layouts/views/dashboards/receiving/misc";
import ManifestReport from "layouts/views/report/manifest";
import SalesDashboard from "layouts/views/dashboards/sales2";
import MainDashboard from "layouts/views/dashboards/main";
import CancelOrder from "layouts/views/inbound/putaway/cancel-order";
import PickslipPickEnquiry from "layouts/views/enquiry/pickslip-pick";
import PickslipPackEnquiry from "layouts/views/enquiry/pickslip-pack";
import OrderTrackingNumberList from "layouts/views/enquiry/order-tracking-number";
import LAHist from "layouts/views/enquiry/la-hist";
import HistoricalInventorySummary from "layouts/views/enquiry/historical-inventory-summary";
import ReceivedItems from "layouts/views/inbound/received-items";
import ShippedItems from "layouts/views/outbound/shipped-items";
import MainDashboard2 from "layouts/views/dashboards/main/index2";
import COReturnCodeList from "layouts/views/setup/co-return-code-mgmt";
import AddCOReturnCode from "layouts/views/setup/co-return-code-mgmt/add-co-return-code";
import EditCOReturnCode from "layouts/views/setup/co-return-code-mgmt/edit-co-return-code";
import SKUBarcodeEnquiry from "layouts/views/enquiry/sku-barcode";
import RecvMainDashboard from "layouts/views/dashboards/main/recv-overall";
import ChangeUserPassword from "layouts/views/setup/change-password-mgmt";
import PackagingMaterialList from "layouts/views/setup/packing-material-mgmt";
import AddPackagingMaterial from "layouts/views/setup/packing-material-mgmt/add-packaging-material";
import EditPackagingMaterial from "layouts/views/setup/packing-material-mgmt/edit-packaging-material";
import OrderDetailsSummary from "layouts/views/enquiry/summary/order-details";
import UploadCO from "layouts/views/inbound/collection-order/upload-co";
import PutawayCancelReport from "layouts/views/report/putaway-cancel";
import StockHoldEnquiry from "layouts/views/enquiry/stock-hold";
import StockAttributesEnquiry from "layouts/views/enquiry/stock-attributes";
import DivisionStockAdjustmentEnquiry from "layouts/views/enquiry/division-stock-adjustment";
//billing
import InboundBillingReportConfiguration from "layouts/views/billing/inbound-billing-report-configuration";
import StorageBillingReportConfiguration from "layouts/views/billing/storage-billing-report-configuration";
import BillingList from "layouts/views/billing";
import AddNewBillingList from "layouts/views/billing/add-new-billing";
import EditBillingList from "layouts/views/billing/edit-billing";
import BillingServiceList from "layouts/views/billing/billing-order-mgmt";
import AddNewBillingService from "layouts/views/billing/billing-order-mgmt/add-billing-service";

import RecvSerialNumberEnquiry from "layouts/views/enquiry/recv-serial-number";
import LoadManifestEnquiry from "layouts/views/enquiry/load-manifest";
import BillingChargeable from "layouts/views/billing/billing-chargeable";
import LocationGroupList from "layouts/views/setup/location-group-mgmt";
import AddLocationGroup from "layouts/views/setup/location-group-mgmt/add-location-group";
import EditLocationGroup from "layouts/views/setup/location-group-mgmt/edit-location-group";
import UpdateLocation from "layouts/views/setup/location-mgmt/bulk-update-location";
import BillingInvoiceList from "layouts/views/billing/billing-invoice";
import EditBillingInvoice from "layouts/views/billing/billing-invoice/edit-billing-invoice";
import ManifestEtrax from "layouts/views/outbound/manifest-etrax";
// import CycleCountVarianceReport from "layouts/views/inventory/cycle-count-mgmt/variance-report";
// import CycleCountVariance from "layouts/views/inventory/cycle-count-mgmt/variance-comparison";
import CycleCountReportPage from "layouts/views/inventory/cycle-count-mgmt/cycle-count-report";
import AddCountry from "layouts/views/setup/country-mgmt/add-country";
import EditCountry from "layouts/views/setup/country-mgmt/edit-country";
import CountryList from "layouts/views/setup/country-mgmt";
import ReceivingScannedEnquiry from "layouts/views/enquiry/receiving-scanned";
import EmptyLocationEnquiry from "layouts/views/enquiry/empty-location";
import ReturnOrderScanEnquiry from "layouts/views/enquiry/return-order-scan";
import KPIUserRangeList from "layouts/views/kpi/kpi-user-range-mgmt";
import AddKPIUserRange from "layouts/views/kpi/kpi-user-range-mgmt/add-kpi-user-range";
import EditKPIUserRange from "layouts/views/kpi/kpi-user-range-mgmt/edit-kpi-user-range";
import KPIProductivityRangeList from "layouts/views/kpi/kpi-productivity-range-mgmt";
import AddKPIProductivityRange from "layouts/views/kpi/kpi-productivity-range-mgmt/add-kpi-productivity-range";
import EditKPIProductivityRange from "layouts/views/kpi/kpi-productivity-range-mgmt/edit-kpi-productivity-range";
import KPITeamList from "layouts/views/kpi/kpi-team-mgmt";
import AddKPITeam from "layouts/views/kpi/kpi-team-mgmt/add-kpi-team";
import EditKPITeam from "layouts/views/kpi/kpi-team-mgmt/edit-kpi-team";
import KPIDashboard from "layouts/views/kpi/kpi-dashboard";
import ReturnOrderManagement from "layouts/views/outbound/return-order";
import PutawayCancelEnquiry from "layouts/views/enquiry/putaway-cancel";
import EditTracking from "layouts/views/internal/edit-tracking";
import EditIntegratedTracking from "layouts/views/internal/edit-integrated-tracking";
import FulfillmentOrder from "layouts/views/outbound/fulfillment-order";
import ReturnOrderWebApi from "layouts/views/outbound/return-order-webapi";
import DelyvaCreateOrderLog from "layouts/views/internal/delyva-create-order-log";
import InterDivisionStockTransferList from "layouts/views/inventory/inter-division-stock-transfer-mgmt";
import AddInterDivisionStockTransfer from "layouts/views/inventory/inter-division-stock-transfer-mgmt/add-inter-division-stock-transfer";
import DivisionList from "layouts/views/setup/division-mgmt";
import AddDivision from "layouts/views/setup/division-mgmt/add-division";
import InterDivisionInventoriesEnquiry from "layouts/views/enquiry/inter-division-inventories";
import UploadInterDivisionTransfer from "layouts/views/inventory/inter-division-stock-transfer-mgmt/upload-inter-division";
import EditBillingService from "layouts/views/billing/billing-order-mgmt/edit-billing-service";
import ReturnItems from "layouts/views/outbound/return-items";
import DivisionTransferList from "layouts/views/inventory/division-transfer-mgmt";
import UploadDivisionTransfer from "layouts/views/inventory/division-transfer-mgmt/upload-division-transfer";
import DivisionInventoriesEnquiry from "layouts/views/enquiry/division-inventories-enquiry";
import DivisionBalanceCheck from "layouts/views/enquiry/division-balance-check";
import DivisionInventoryList from "layouts/views/inventory/division-mgmt";
import DivisionList2 from "layouts/views/inventory/division-index";
import DivisionMovementEnquiry from "layouts/views/enquiry/division-movement";
import DivisionGRNEnquiry from "layouts/views/enquiry/division-grn";
import DivisionAdjustmentList from "layouts/views/inventory/division-adjustment-mgmt";
import UploadDivisionAdjustment from "layouts/views/inventory/division-adjustment-mgmt/upload-division-adjustment";
import DivisionStockTransferEnquiry from "layouts/views/enquiry/division-stock-transfer";
import DivisionTransferEnquiry from "layouts/views/enquiry/division-transfer";
// Routes configuration
const routes = [
  {
    type: "collapse",
    name: "#fullName#",
    key: "full-Name",
    //icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
    icon: <Icon fontSize="medium">person</Icon>,
    collapse: [
      // {
      //   name: "My Profile",
      //   key: "my-profile",
      //   route: "/pages/profile/profile-overview",
      //   component: <ProfileOverview />,
      // },
      // {
      //   name: "Settings",
      //   key: "profile-settings",
      //   route: "/pages/account/settings",
      //   component: <Settings />,
      // },
      {
        name: "Change Password",
        key: "change-password",
        route: "/change-password",
        anonymous: true,
        component: <ChangeUserPassword  />,
      },
      {
        name: "Logout",
        key: "logout",
        route: "/login",
        anonymous: true,
        component: <SignInBasic triggerLogout />,
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      // {
      //   name: "Analytics",
      //   key: "analytics",
      //   route: "/dashboards/analytics",
      //   component: <Analytics />,
      // },
      // {
      //   name: "Sales",
      //   key: "sales",
      //   route: "/dashboards/sales",
      //   component: <Sales />,
      // },
      // {
      //   name: "Home",
      //   key: "home",
      //   route: "/dashboards/home",
      //   component: <MainDashboard />,
      // },
      {
        name: "Sales Overall",
        key: "sales-overall",
        route: "/dashboards/sales-overall",
        component: <MainDashboard2 />,
      },
      {
        name: "Inbound Overall",
        key: "inbound-overall",
        route: "/dashboards/inbound-overall",
        component: <RecvMainDashboard />,
      },
      {
        name: "Purchase Order",
        key: "po-dashboard",
        route: "/dashboards/po-dashboard",
        component: <PODashboard />,
      },
      {
        name: "Collection Order",
        key: "co-dashboard",
        route: "/dashboards/co-dashboard",
        component: <CODashboard />,
      },
      {
        name: "Misc Receiving",
        key: "misc-dashboard",
        route: "/dashboards/misc-dashboard",
        component: <MiscDashboard />,
      },
      {
        name: "Sales",
        key: "sales-dashboard",
        route: "/dashboards/sales-dashboard",
        component: <SalesDashboard />,
      },
      {
            name: "KPI Dashboard",
            key: "kpi-dashboard",
            route: "/dashboards/kpi-dashboard",
            component: <KPIDashboard />,
          },
    ],
  },
  { type: "title", title: "Module", key: "title-pages" },
  // {
  //   type: "collapse",
  //   name: "Enquiry",
  //   key: "enquiry",
  //   icon: <Icon fontSize="medium">receipt_long</Icon>,
  //   collapse: [],
  // },
  {
    type: "collapse",
    name: "Inbound",
    key: "inbound",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Purchase Order",
        key: "po",
        icon: "",
        collapse: [
          {
            name: "PO Mgmt",
            key: "po-management",
            route: "/inbound/po",
            component: <POList />,
          },
          {
            name: "Add PO",
            key: "add-po",
            route: "/inbound/po/add",
            component: <AddPO />,
          },
          {
            name: "Edit PO",
            key: "edit-po",
            route: "/inbound/po/edit",
            visible: true,
            component: <EditPO />,
          },
          {
            name: "Upload PO",
            key: "upload-po",
            route: "/inbound/po/upload",
            component: <UploadPO />,
          },
          // {
          //   name: "test",
          //   key: "test1",
          //   route: "/inbound/po/test",
          //   component:<TestLayout/>
          // }
        ],
      },
      {
        type: "collapse",
        name: "ASN",
        key: "asn",
        icon: "",
        collapse: [
          {
            name: "ASN Mgmt",
            key: "asn-management",
            route: "/inbound/asn",
            component: <ASNList />,
          },
          {
            name: "Add ASN",
            key: "add-asn",
            route: "/inbound/asn/add",
            component: <AddASN />,
          },
          {
            name: "Edit ASN",
            key: "edit-asn",
            route: "/inbound/asn/edit",
            visible: true,
            component: <EditASN />,
          },
        ],
      },
      {
        type: "collapse",
        name: "PO Receiving",
        key: "po-receiving",
        icon: "",
        collapse: [
          {
            name: "PO Receiving Mgmt",
            key: "po-receiving-management",
            route: "/inbound/po-receiving",
            component: <PORecvList />,
          },
          {
            name: "Add PO Receiving",
            key: "add-po-receiving",
            route: "/inbound/po-receiving/add",
            component: <AddPOReceiving />,
          },
          {
            name: "Edit PO Receiving",
            key: "edit-po-receiving",
            route: "/inbound/po-receiving/edit",
            visible: true,
            component: <EditPOReceiving />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Collection Order",
        key: "co",
        icon: "",
        collapse: [
          {
            name: "CO Mgmt",
            key: "co-management",
            route: "/inbound/co",
            component: <COList />,
          },

          {
            name: "Add CO",
            key: "add-co",
            route: "/inbound/co/add",
            component: <AddCO />,
          },
          {
            name: "Edit CO",
            key: "edit-co",
            route: "/inbound/co/edit",
            visible: true,
            component: <EditCO />,
          },
          {
            name: "Upload CO",
            key: "upload-co",
            route: "/inbound/co/upload",
            component: <UploadCO />,
          },
        ],
      },
      {
        type: "collapse",
        name: "CO Receiving",
        key: "co-receiving",
        icon: "",
        collapse: [
          {
            name: "CO Receiving Mgmt",
            key: "co-receiving-management",
            route: "/inbound/co-receiving",
            component: <CORecvList />,
          },

          {
            name: "Add CO Receiving",
            key: "add-co-receiving",
            route: "/inbound/co-receiving/add",
            component: <AddCOReceiving />,
          },
          {
            name: "Edit CO Receiving",
            key: "edit-co-receiving",
            route: "/inbound/co-receiving/edit",
            visible: true,
            component: <EditCOReceiving />,
          },
        ],
      },
      {
        type: "collapse",
        name: "MISC Receiving",
        key: "receiving",
        icon: "",
        collapse: [
          {
            name: "MISC Receiving Mgmt",
            key: "receiving-management",
            route: "/inbound/receiving",
            component: <RecvList />,
          },
          {
            name: "Add MISC Receiving",
            key: "add-receiving",
            route: "/inbound/receiving/add",
            component: <AddReceiving />,
          },
          {
            name: "Edit Receiving",
            key: "edit-po",
            route: "/inbound/receiving/edit",
            component: <EditReceiving />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Putaway",
        key: "putaway",
        icon: "",
        collapse: [
          {
            name: "Putaway Mgmt",
            key: "Putaway-management",
            route: "/inbound/putaway",
            component: <PutawayList />,
          },
          {
            name: "Edit Putaway",
            key: "edit-putaway",
            route: "/inbound/putaway/edit",
            component: <EditPutaway />,
            visible: true,
          },
          {
            name: "Cancel Order",
            key: "cancel-order",
            route: "/inbound/putaway/cancel-order",
            component: <CancelOrder />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Received API",
        key: "received-items",
        icon: "",
        collapse: [
          {
            name: "Update Received API",
            key: "Received-Items-management",
            route: "/inbound/received-items",
            component: <ReceivedItems />,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Outbound",
    key: "outbound",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "ESO",
        key: "eso",
        icon: "",
        collapse: [
          {
            name: "ESO Mgmt",
            key: "eso-management",
            route: "/outbound/eso",
            component: <ESOList />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Sales Order",
        key: "so",
        icon: "",
        collapse: [
          {
            name: "SO Mgmt",
            key: "so-management",
            route: "/outbound/so",
            component: <SOList />,
          },
          {
            name: "Add SO",
            key: "add-so",
            route: "/outbound/so/add",
            component: <AddSO />,
          },
          {
            name: "Edit SO",
            key: "edit-so",
            route: "/outbound/so/edit",
            visible: true,
            component: <EditSO />,
          },
          {
            name: "Upload SO",
            key: "upload-so",
            route: "/outbound/so/upload",
            component: <UploadSO />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Task Assignment",
        key: "task-assignment",
        icon: "",
        collapse: [
          {
            name: "Task Assignment Mgmt",
            key: "task-assignment-management",
            route: "/outbound/task-assignment",
            component: <TaskAssignmentList />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Delivery Order",
        key: "do",
        icon: "",
        collapse: [
          {
            name: "DO Mgmt",
            key: "do-management",
            route: "/outbound/do",
            component: <DOList />,
          },
          {
            name: "Edit DO",
            key: "edit-do",
            route: "/outbound/do/edit",
            visible: true,
            component: <EditDO />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Load Manifest",
        key: "loadManifest",
        icon: "",
        collapse: [
          {
            name: "Manifest Mgmt",
            key: "manifest-management",
            route: "/outbound/load-manifest",
            component: <ManifestList />,
          },
          {
            name: "Add Load Manifest",
            key: "add-loadManifest",
            route: "/outbound/load-manifest/add",
            component: <AddLoadManifest />,
          },
          {
            name: "Edit Load Manifest",
            key: "edit-loadManifest",
            route: "/outbound/load-manifest/edit",
            visible: true,
            component: <EditLoadManifest />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Proof Of Delivery",
        key: "proofOfDelivery",
        icon: "",
        collapse: [
          {
            name: "Proof Of Delivery",
            key: "proofOfDelivery-management",
            route: "/outbound/proofOfDelivery",
            component: <ProofOfDelivery />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Task List",
        key: "task-list",
        icon: "",
        collapse: [
          {
            name: "Task List",
            key: "task-list-management",
            route: "/outbound/task-list",
            component: <TaskList />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Shipped API",
        key: "shipped-items",
        icon: "",
        collapse: [
          {
            name: "Update Shipped API",
            key: "Shipped-Items-management",
            route: "/outbound/shipped-items",
            component: <ShippedItems />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Manifest to Etrax",
        key: "manifest-etrax",
        icon: "",
        collapse: [
          {
            name: "Manifest to Etrax API",
            key: "manifest-etrax-management",
            route: "/outbound/manifest-etrax",
            component: <ManifestEtrax />,
          },
          {
            name: "Update Tracking",
            key: "update-tracking",
            route: "/outbound/tracking/edit",
            component: <EditTracking />,
            visible: true,
          },
          {
            name: "Update Integrated Tracking",
            key: "update-integrated-tracking",
            route: "/outbound/tracking/edit-integrated",
            component: <EditIntegratedTracking />,
            visible: true,
          },
          {
            name: "Fulfillment Order",
            key: "fulfillment-order",
            route: "/outbound/fulfillment",
            component: <FulfillmentOrder />,
            visible: true,
          },
          {
            name: "Delyva Create Order Log",
            key: "delyva-create-order-log",
            route: "/outbound/delyva-create-order-log",
            component: <DelyvaCreateOrderLog />,
            visible: true,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Return",
    key: "return-order",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Return Order",
        key: "return-order",
        icon: "",
        collapse: [
          {
            name: "Return Order Management List",
            key: "return-order-management",
            route: "/return-order/return-order",
            component: <ReturnOrderManagement/>,
          },
          {
            name: "Return Order (WebApi)",
            key: "return-order-webapi",
            route: "/return-order/return-order-webapi",
            component: <ReturnOrderWebApi />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Return Api",
        key: "return-items",
        icon: "",
        collapse: [
          {
            name: "Update Return API",
            key: "return-items-management",
            route: "/return-order/return-items",
            component: <ReturnItems/>,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Billing Setup",
        key: "billing",
        icon: "",
        collapse: [
          {
            name: "Billing Mgmt",
            key: "billing-mgmt",
            route: "/billing/billing",
            component: <BillingList/>,
          },
          {
            name: "Add New Billing",
            key: "add-new-billing",
            route: "/billing/add-new-billing",
            component: <AddNewBillingList/>,
          },
          {
            name: "Edit Billing",
            key: "edit-billing",
            route: "/billing/edit-billing",
            component: <EditBillingList/>,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Billing Service",
        key: "billing-service",
        icon: "",
        collapse: [
          {
            name: "Billing Service Mgmt",
            key: "billing-service-mgmt",
            route: "/billing/billing-service",
            component: <BillingServiceList/>,
          },
          {
            name: "Add New Billing Service",
            key: "add-new-billing-service",
            route: "/billing/add-new-billing-service",
            component: <AddNewBillingService/>,
          },
          {
            name: "Edit Billing Service",
            key: "edit-billing-service",
            route: "/billing/edit-billing-service",
            component: <EditBillingService/>,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Billing Invoice",
        key: "billing-invoice",
        icon: "",
        collapse: [
          {
            name: "Billing Invoice",
            key: "billing-invoice-mgmt",
            route: "/billing/billing-invoice",
            component: <BillingInvoiceList/>,
          },
          {
            name: "Edit Billing Invoice",
            key: "edit-billing-invoice",
            route: "/billing/billing-invoice/edit",
            component: <EditBillingInvoice/>,
            visible: true,
          }
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Inventory",
    key: "inventory",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Inventory list",
        key: "inventory-list",
        collapse: [
          {
            name: "SKU",
            key: "inventory-sku-management",
            route: "/inventory/sku",
            component: <InventoryList />,
          },
          {
            name: "Inventory SKU",
            key: "inventory-sku",
            route: "/inventory/sku/details",
            component: <InventoryList2 />,
            visible: true,
          },
          {
            name: "Location",
            key: "inventory-location-management",
            route: "/inventory/location",
            component: <InventoryLocationList />,
          },
          {
            name: "Inventory Location",
            key: "inventory-location",
            route: "/inventory/location/details",
            component: <InventorySKUDetails />,
            visible: true,
          },
          {
            name: "Division SKU",
            key: "division-inventory-sku-management",
            route: "/inventory/division-sku",
            component: <DivisionInventoryList />,
          },
          {
            name: "Division Inventory SKU",
            key: "division-inventory-sku",
            route: "/inventory/division-sku/details",
            component: <DivisionList2 />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Adjustment",
        key: "adjustment",
        collapse: [
          {
            name: "Adjustment Mgmt",
            key: "adjustment-management",
            route: "/inventory/adjustment",
            component: <AdjustmentList />,
          },
          {
            name: "Add Adjustment",
            key: "add-adjustment",
            route: "/inventory/adjustment/add",
            component: <AddAdjustment />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Stock Hold",
        key: "stock-hold",
        collapse: [
          {
            name: "Stock Hold Mgmt",
            key: "stock-hold-management",
            route: "/inventory/stock-hold",
            component: <StockHoldList />,
          },
          {
            name: "Add Stock Hold",
            key: "add-stock-hold",
            route: "/inventory/stock-hold/add",
            component: <AddStockHold />,
          },
          {
            name: "Add Stock Unhold",
            key: "add-stock-unhold",
            route: "/inventory/stock-hold/unhold",
            visible: true,
            component: <AddStockUnhold />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Stock Attributes",
        key: "stock-attributes",
        collapse: [
          {
            name: "Stock Attributes Mgmt",
            key: "stock-attributes-management",
            route: "/inventory/stock-attributes",
            component: <StockAttributesList />,
          },
          {
            name: "Edit Stock Attributes",
            key: "edit-stock-attributes",
            route: "/inventory/stock-attributes/edit",
            component: <EditStockAttributes />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Stock Transfer",
        key: "stock-transfer",
        collapse: [
          {
            name: "Stock Transfer Mgmt",
            key: "stock-transfer-management",
            route: "/inventory/stock-transfer",
            component: <StockTransferList />,
          },
          {
            name: "Add Stock Transfer",
            key: "add-stock-transfer",
            route: "/inventory/stock-transfer/add",
            component: <AddStockTransfer />,
          },
        ],
      },
      // {
      //   type: "collapse",
      //   name: "Inter-Division Transfer",
      //   key: "inter-division-stock-transfer",
      //   collapse: [
      //     {
      //       name: "Inter-Division Transfer Mgmt",
      //       key: "inter-division-stock-transfer-management",
      //       route: "/inventory/inter-division-stock-transfer",
      //       component: <InterDivisionStockTransferList />,
      //     },
      //     {
      //       name: "Add Inter-Division Transfer",
      //       key: "add-inter-division-add-stock-transfer",
      //       route: "/inventory/inter-division-stock-transfer/add",
      //       component: <AddInterDivisionStockTransfer />,
      //     },
      //     {
      //       name: "Upload Inter-Division Transfer",
      //       key: "upload-inter-division-upload-stock-transfer",
      //       route: "/inventory/inter-division-stock-transfer/upload",
      //       component: <UploadInterDivisionTransfer />,
      //     },
      //   ],
      // },
      {
        type: "collapse",
        name: "Division Transfer",
        key: "division-transfer",
        collapse: [
          {
            name: "Division Transfer Mgmt",
            key: "division-transfer-management",
            route: "/inventory/division-transfer",
            component: <DivisionTransferList />,
          },
          {
            name: "Upload Division Transfer",
            key: "upload-division-stock-transfer",
            route: "/inventory/division-transfer/upload",
            component: <UploadDivisionTransfer />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Division Adjustment",
        key: "division-adjustment",
        collapse: [
          {
            name: "Division Adjustment Mgmt",
            key: "division-adjustment-management",
            route: "/inventory/division-adjustment",
            component: <DivisionAdjustmentList />,
          },
          {
            name: "Upload Division Adjustment",
            key: "upload-division-stock-adjustment",
            route: "/inventory/division-adjustment/upload",
            component: <UploadDivisionAdjustment />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Physical Count",
        key: "physicalcount",
        collapse: [
          {
            name: "Generate Physical Count",
            key: "generate-physical-count",
            route: "/inventory/physicalcount/generate",
            component: <GeneratePhysicalCount />,
          },
          {
            name: "Update Physical Count",
            key: "update-physical-count",
            route: "/inventory/physicalcount/update",
            component: <UpdatePhysicalCount />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Cycle Count",
        key: "cyclecount",
        collapse: [
          {
            name: "Generate Cycle Count",
            key: "generate-cycle-count",
            route: "/inventory/cyclecount/generate",
            component: <GenerateCycleCount />,
          },
          {
            name: "Update Cycle Count",
            key: "update-cycle-count",
            route: "/inventory/cyclecount/update",
            component: <UpdateCycleCount />,
          },
          // {
          //   name: "Variance Report",
          //   key: "cycle-count-variance-report",
          //   route: "/inventory/cyclecount/variance-report",
          //   component: <CycleCountVarianceReport />,
          // },
          // {
          //   name: "Cycle Count Variance",
          //   key: "cycle-count-variance",
          //   route: "/inventory/cyclecount/variance",
          //   component: <CycleCountVariance />,
          // },
          {
            name: "Cycle Count Report",
            key: "cycle-count-report-inventory",
            route: "/inventory/cyclecount/report",
            component: <CycleCountReportPage />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Opening Balance",
        key: "openingbalance",
        collapse: [
          {
            name: "Opening Balance",
            key: "add-opening-balance",
            route: "/inventory/openingbalance",
            component: <OpeningBalance />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Replenishment",
        key: "replenishment",
        collapse: [
          {
            name: "Add New Replenishment",
            key: "add-new-replenishment",
            route: "/inventory/replenishment-mgmt/generate",
            component: <AddNewReplenishment />,
          },
          {
            name: "Update Replenishment",
            key: "update-replenishment",
            route: "/inventory/replenishment-mgmt/update",
            component: <UpdateReplenishment />,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Report",
    key: "report",
    icon: <Icon fontSize="medium">receipt_long</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Inbound",
        key: "inbound-report",
        collapse: [
          {
            name: "MISC Report",
            key: "misc-report",
            route: "/report/misc-report",
            component: <MISCReport />,
          },
          {
            name: "CO Receiving Report",
            key: "co-recv-report",
            route: "/report/co-recv-report",
            component: <COReport />,
          },
          {
            name: "PO Receiving Report",
            key: "po-recv-report",
            route: "/report/po-recv-report",
            component: <POReport />,
          },
          {
            name: "Putaway Report",
            key: "putaway-report",
            route: "/report/putaway-report",
            component: <PutawayReport />,
          },
          {
            name: "Putaway Cancel Report",
            key: "putaway-cancel-report",
            route: "/report/putaway-cancel-report",
            component: <PutawayCancelReport />,
          },
          {
            name: "PO Receiving",
            key: "po-receiving",
            route: "/report/po-receiving",
            component: <POReceivingEnquiry />,
          },
          {
            name: "GRN",
            key: "grn-report",
            route: "/report/grn-report",
            component: <GRNReportEnquiry />,
          },
          {
            name: "Division GRN",
            key: "division-grn-report",
            route: "/report/division-grn-report",
            component: <DivisionGRNEnquiry />,
          },
          {
            name: "Receiving Scanned",
            key: "receiving-scanned",
            route: "/report/receiving-scanned",
            component: <ReceivingScannedEnquiry />,
          },
          {
            name: "Return Order",
            key: "return-order",
            route: "/report/return-order",
            component: <ReturnOrderScanEnquiry />,
          },
          {
            name: "Putaway Cancel",
            key: "putaway-cancel",
            route: "/report/putaway-cancel",
            component: <PutawayCancelEnquiry />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Outbound",
        key: "outbound-report",
        collapse: [
          {
            name: "Pickslip Report",
            key: "pickslip-report",
            route: "/report/pickslip-report",
            component: <PickslipReport />,
          },
          {
            name: "Delivery Order Report",
            key: "do-report",
            route: "/report/do-report",
            component: <DeliveryOrderReport />,
          },
          {
            name: "Manifest Report",
            key: "manifest-report",
            route: "/report/manifest-report",
            component: <ManifestReport />,
          },
          {
            name: "Order Details Status",
            key: "order-details-status",
            route: "/report/order-details-status",
            component: <OrderDetailsStatusEnquiry />,
          },
          {
            name: "Order Summary",
            key: "order-details-summary",
            route: "/report/order-details-summary",
            component: <OrderDetailsSummary />,
          },
          {
            name: "Pickslip",
            key: "pickslip-report_",
            route: "/report/pickslip",
            component: <PickslipEnquiry />,
          },
          {
            name: "Pickslip Pick",
            key: "pickslip-pick",
            route: "/report/pickslip-pick",
            component: <PickslipPickEnquiry />,
          },
          {
            name: "Pickslip Pack",
            key: "pickslip-pack",
            route: "/report/pickslip-pack",
            component: <PickslipPackEnquiry />,
          },
          {
            name: "Load Manifest",
            key: "load-manifest",
            route: "/report/load-manifest",
            component: <LoadManifestEnquiry />,
          },
          {
            name: "Order Tracking Number",
            key: "order-tracking-number",
            route: "/report/order-tracking-number",
            component: <OrderTrackingNumberList />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Inventory",
        key: "inventory-report",
        collapse: [
          {
            name: "Historical Inventory",
            key: "historical-inventory",
            route: "/report/historical-inventory",
            component: <LAHist />,
          },
          {
            name: "H.I. Summary",
            key: "historical-inventory-summary",
            route: "/report/historical-inventory-summary",
            component: <HistoricalInventorySummary />,
          },
          {
            name: "Stock Inventory",
            key: "stock-inventory",
            route: "/report/stock-inventory",
            component: <StockInventoryEnquiry />,
          },
          {
            name: "SKU Movement",
            key: "sku-movement",
            route: "/report/sku-movement",
            component: <SKUMovementEnquiry />,
          },
          {
            name: "SKU M. Summary",
            key: "sku-movement-summary",
            route: "/report/sku-movement-summary",
            component: <SKUMovementSummaryEnquiry />,
          },
          {
            name: "Division Movement",
            key: "division-movement",
            route: "/report/division-movement",
            component: <DivisionMovementEnquiry />,
          },
          {
            name: "Aging",
            key: "aging-report",
            route: "/report/aging-report",
            component: <AgingReportEnquiry />,
          },
          {
            name: "Shelf Life",
            key: "shelf-life-report",
            route: "/report/shelf-life-report",
            component: <ShelfLifeReportEnquiry />,
          },
          {
            name: "Adjustment",
            key: "adjustment-report",
            route: "/report/adjustment-report",
            component: <AdjustmentEnquiry />,
          },
          {
            name: "Transfer",
            key: "transfer-report",
            route: "/report/transfer-report",
            component: <TransferEnquiry />,
          },
          {
            name: "Division Transfer",
            key: "division-transfer-report",
            route: "/report/division-transfer-report",
            component: <DivisionTransferEnquiry />,
          },
          {
            name: "SKU Barcode",
            key: "sku-barcode",
            route: "/report/sku-barcode",
            component: <SKUBarcodeEnquiry />,
          },
          {
            name: "Physical Count",
            key: "physical-count-report",
            route: "/report/physical-count-report",
            component: <PhysicalCountEnquiry />,
          },
          {
            name: "Cycle Count",
            key: "cycle-count-report",
            route: "/report/cycle-count-report",
            component: <CycleCountEnquiry />,
          },
          {
            name: "Stock Hold",
            key: "stock-hold-report",
            route: "/report/stock-hold-report",
            component: <StockHoldEnquiry />,
          },
          {
            name: "Stock Attributes",
            key: "stock-attributes-report",
            route: "/report/stock-attributes-report",
            component: <StockAttributesEnquiry />,
          },
          {
            name: "Recv Serial Number",
            key: "recv-serial-number",
            route: "/report/recv-serial-number",
            component: <RecvSerialNumberEnquiry />,
          },
          {
            name: "Empty Location",
            key: "empty-location",
            route: "/report/empty-location",
            component: <EmptyLocationEnquiry />,
          },
          {
            name: "Inter-Division Inventories",
            key: "inter-division-inventories",
            route: "/report/inter-division-inventories",
            component: <InterDivisionInventoriesEnquiry />,
          },
          {
            name: "Division Inventories",
            key: "division-inventories",
            route: "/report/division-inventories",
            component: <DivisionInventoriesEnquiry />,
          },
          {
            name: "Division Balance Check",
            key: "division-balance-check",
            route: "/report/division-balance-check",
            component: <DivisionBalanceCheck />,
          },
          {
            name: "Division Stock Adjustment",
            key: "division-stock-adjustment",
            route: "/report/division-stock-adjustment",
            component: <DivisionStockAdjustmentEnquiry />,
          },
          {
            name: "Division Stock Transfer",
            key: "division-stock-transfer-report",
            route: "/report/division-stock-transfer-report",
            component: <DivisionStockTransferEnquiry />,
          },   
        ],
      },
      {
        type: "collapse",
        name: "Billing",
        key: "billing-report",
        collapse: [
          {
            name: "Billing Chargeable",
            key: "billing-chargeable",
            route: "/report/billing-chargeable",
            component: <BillingChargeable />,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "KPI",
    key: "kpi",
    icon: <Icon fontSize="medium">task</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "KPI User Range",
        key: "kpi-user-range",
        collapse: [
          {
            name: "KPI User Range Mgmt",
            key: "kpi-user-range-management",
            route: "/kpi/kpi-user-range",
            component: <KPIUserRangeList />,
          },
          {
            name: "Add KPI User Range",
            key: "add-kpi-user-range",
            route: "/kpi/kpi-user-range/add",
            component: <AddKPIUserRange />,
          },
          {
            name: "Edit KPI User Range",
            key: "edit-kpi-user-range",
            route: "/kpi/kpi-user-range/edit",
            component: <EditKPIUserRange />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "KPI Productivity",
        key: "kpi-productivity-range",
        collapse: [
          {
            name: "KPI Productivity Mgmt",
            key: "kpi-productivity-range-management",
            route: "/kpi/kpi-productivity-range",
            component: <KPIProductivityRangeList />,
          },
          {
            name: "Add KPI Productivity",
            key: "add-kpi-productivity-range",
            route: "/kpi/kpi-productivity-range/add",
            component: <AddKPIProductivityRange />,
          },
          {
            name: "Edit KPI Productivity Range",
            key: "edit-kpi-productivity-range",
            route: "/kpi/kpi-productivity-range/edit",
            component: <EditKPIProductivityRange />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "KPI Team",
        key: "kpi-team",
        collapse: [
          {
            name: "KPI Team Mgmt",
            key: "kpi-team-management",
            route: "/kpi/kpi-team",
            component: <KPITeamList />,
          },
          {
            name: "Add KPI Team",
            key: "add-kpi-team",
            route: "/kpi/kpi-team/add",
            component: <AddKPITeam />,
          },
          {
            name: "Edit KPI Team",
            key: "edit-kpi-team",
            route: "/kpi/kpi-team/edit",
            component: <EditKPITeam />,
            visible: true,
          },
        ],
      },
      // {
      //   type: "collapse",
      //   name: "KPI DashBoard",
      //   key: "kpi-dashboard",
      //   collapse: [
      //     {
      //       name: "KPI Dashboard",
      //       key: "kpi-dashboard",
      //       route: "/kpi/kpi-dashboard",
      //       component: <KPIDashboard />,
      //     },
      //   ],
      // },
      
    ]
  },
  {
    type: "collapse",
    name: "Setup",
    key: "setup",
    icon: <Icon fontSize="medium">settings</Icon>,
    collapse: [
      // {
      //   name: "Customer Management",
      //   key: "customer-management",
      //   route: "/pages/setup/customer-management",
      //   component: <CustomerManagement />,
      // },
      // {
      //   name: "User Management",
      //   key: "user-management",
      //   route: "/pages/setup/user-management",
      //   component: <UserManagement />,
      // },
      // {
      //   name: "New User",
      //   key: "new-user",
      //   route: "/pages/users/new-user",
      //   component: <NewUser />,
      //   visible: false,
      // },
      // {
      //   type: "collapse",
      //   name: "drawer1",
      //   key: "drawer1",
      //   icon: "",
      //   collapse: [
      //     {
      //       name: "drawer-1",
      //       key: "drawer-1",
      //       route: "/drawer1",
      //       component: <SampleDrawer/>,
      //     }
      //   ],
      // },
      {
        type: "collapse",
        name: "Company",
        key: "company",
        icon: "",
        collapse: [
          {
            name: "Company Mgmt",
            key: "company-management",
            route: "/setup/company",
            component: <CompanyList />,
          },
          {
            name: "Add Company",
            key: "add-company",
            route: "/setup/company/add",
            component: <AddCompany />,
          },
          {
            name: "Edit Company",
            key: "edit-company",
            route: "/setup/company/edit",
            component: <EditCompany />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Customer",
        key: "customer",
        icon: <Icon fontSize="medium">image</Icon>,
        collapse: [
          {
            name: "Customer Mgmt",
            key: "customer-management",
            route: "/setup/customer",
            component: <CustomerList />,
          },
          {
            name: "Add Customer",
            key: "add-customer",
            route: "/setup/customer/add",
            component: <AddCustomer />,
          },
          {
            name: "Edit Customer",
            key: "edit-customer",
            route: "/setup/customer/edit",
            component: <EditCustomer />,
            visible: true,
          },
          {
            name: "Add Cust Wh Setting",
            key: "add-customer-wh-setting",
            route: "/setup/customer/wh-setting/add",
            component: <AddCustomerWarehouseSetting2 />,
            visible: true,
          },
          {
            name: "Add Customer Carrier",
            key: "add-customer-carrier",
            route: "/setup/customer/carrier/add",
            component: <AddCustCarrier2 />,
            visible: true,
          },
          {
            name: "Add API Setting",
            key: "add-api-setting",
            route: "/setup/customer/api-setting/add",
            component: <AddAPISetting />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Warehouse",
        key: "warehouse",
        icon: "",
        collapse: [
          {
            name: "Warehouse Mgmt",
            key: "warehouse-management",
            route: "/setup/warehouse",
            component: <WarehouseList />,
          },
          {
            name: "Add Warehouse",
            key: "add-warehouse",
            route: "/setup/warehouse/add",
            component: <AddWarehouse />,
          },
          {
            name: "Edit Warehouse",
            key: "edit-warehouse",
            route: "/setup/warehouse/edit",
            component: <EditWarehouse />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Consignee",
        key: "consignee",
        collapse: [
          {
            name: "Consignee Mgmt",
            key: "consignee-mgmt",
            route: "/setup/consignee",
            component: <ConsigneeList />,
          },
          {
            name: "Add Consignee",
            key: "add-consignee",
            route: "/setup/consignee/add",
            component: <AddConsignee />,
          },
          {
            name: "Edit Consignee",
            key: "edit-consignee",
            route: "/setup/consignee/edit",
            component: <EditConsignee />,
            visible: true,
          },
          {
            name: "Upload Consignee",
            key: "upload-consignee",
            route: "/setup/consignee/upload",
            component: <UploadConsignee />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Zone",
        key: "zone",
        collapse: [
          {
            name: "Zone Mgmt",
            key: "zone-management",
            route: "/setup/zone",
            component: <ZoneList />,
          },
          {
            name: "Add Zone",
            key: "add-zone",
            route: "/setup/zone/add",
            component: <AddZone />,
          },
          {
            name: "Edit Zone",
            key: "edit-zone",
            route: "/setup/zone/edit",
            component: <EditZone />,
            visible: true,
          },
          {
            name: "Upload Zone",
            key: "upload-zone",
            route: "/setup/zone/upload",
            component: <UploadZone />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Location",
        key: "location",
        collapse: [
          {
            name: "Location Mgmt",
            key: "location-management",
            route: "/setup/location",
            component: <LocationList />,
          },
          {
            name: "Add Location",
            key: "add-location",
            route: "/setup/location/add",
            component: <AddLocation />,
          },
          {
            name: "Edit Location",
            key: "edit-location",
            route: "/setup/location/edit",
            component: <EditLocation />,
            visible: true,
          },
          {
            name: "Upload Location",
            key: "upload-location",
            route: "/setup/location/upload",
            component: <UploadLocation />,
          },
          {
            name: "Bulk Update Location",
            key: "bulk-update-location",
            route: "/setup/location/bulk-update",
            component: <UpdateLocation />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Location Group",
        key: "location-group",
        collapse: [
          {
            name: "Location Group Mgmt",
            key: "location-group-management",
            route: "/setup/location-group",
            component: <LocationGroupList />,
          },
          {
            name: "Add Location Group",
            key: "add-location-group",
            route: "/setup/location-group/add",
            component: <AddLocationGroup />,
          },
          {
            name: "Edit Location Group",
            key: "edit-location-group",
            route: "/setup/location-group/edit",
            component: <EditLocationGroup />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Vendor",
        key: "vendor",
        collapse: [
          {
            name: "Vendor Mgmt",
            key: "vendor-management",
            route: "/setup/vendor",
            component: <VendorList />,
          },
          {
            name: "Add Vendor",
            key: "add-vendor",
            route: "/setup/vendor/add",
            component: <AddVendor />,
          },
          {
            name: "Edit Vendor",
            key: "edit-vendor",
            route: "/setup/vendor/edit",
            component: <EditVendor />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "SKU",
        key: "sku",
        collapse: [
          // {
          //   name:"SKU Mgmt",
          //   key:"sku-management",
          //   route:"/setup/sku",
          //   component:<SKUManagement/>
          // },
          // {
          //   name:"SKU Mgmt",
          //   key:"sku-management",
          //   route:"/setup/sku",
          //   component:<Mgmt/>
          // },
          {
            name: "SKU Mgmt",
            key: "sku-management",
            route: "/setup/sku",
            component: <SKUList />,
          },
          // {
          //   name: "Add SKU",
          //   key: "add-sku",
          //   route: "/setup/sku/add",
          //   component: <AddSKU />,
          // },
          {
            name: "Add SKU",
            key: "add-sku",
            route: "/setup/sku/add",
            component: <AddSKU2 />,
          },
          // {
          //   name: "Add SKU Kit",
          //   key: "add-sku-kit",
          //   route: "/setup/sku/kit/add",
          //   component: <AddKitSKU />,
          // },
          // {
          //   name: "Edit SKU",
          //   key: "edit-sku",
          //   route: "/setup/sku/:code",
          //   component: <EditSKU />,
          //   visible:true
          // },
          {
            name: "Edit SKU",
            key: "edit-sku",
            route: "/setup/sku/edit",
            component: <EditSKU2 />,
            visible: true,
          },
          {
            name: "Edit SKU Kit",
            key: "edit-sku-kit",
            route: "/setup/sku/kit/edit",
            component: <EditKitSKU />,
            visible: true,
          },
          {
            name: "Upload SKU",
            key: "upload-sku",
            route: "/setup/sku/upload",
            component: <UploadSKU />,
          },
          {
            name: "Upload SKU Pack Type Weight",
            key: "upload-sku-packtype-weight",
            route: "/setup/sku/packtype-weight/upload",
            component: <UploadSKUPackTypeWeight />,
          },
          // {
          //   name: "Upload SKU Kit",
          //   key: "upload-sku-kit",
          //   route: "/setup/sku/kit/upload",
          //   component: <UploadSKUKit />,
          // },
        ],
      },
      {
        type: "collapse",
        name: "UOM",
        key: "uom",
        icon: <Icon fontSize="medium">memory</Icon>,
        collapse: [
          {
            name: "UOM Mgmt",
            key: "uom-management",
            route: "/setup/uom",
            component: <UOMList />,
          },
          {
            name: "Add UOM",
            key: "add-uom",
            route: "/setup/uom/add",
            component: <AddUOM />,
          },
          {
            name: "Edit UOM",
            key: "edit-uom",
            route: "/setup/uom/edit",
            component: <EditUOM />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Carrier",
        key: "carrier",
        icon: <Icon fontSize="medium">car_repair</Icon>,
        collapse: [
          {
            name: "Carrier Mgmt",
            key: "carrier-management",
            route: "/setup/carrier",
            component: <CarrierList />,
          },
          {
            name: "Add Carrier",
            key: "add-carrier",
            route: "/setup/carrier/add",
            component: <AddCarrier />,
          },
          {
            name: "Edit Carrier",
            key: "edit-carrier",
            route: "/setup/carrier/edit",
            component: <EditCarrier />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Vendor SKU",
        key: "vendorSKU",
        collapse: [
          // {
          //   name: "Vendor SKU Mgmt",
          //   key: "vendor-sku-mgmt",
          //   route: "/setup/vendor-sku",
          //   component: <VendorSKUManagement />
          // },
          // {
          //   name: "Vendor SKU Mgmt2",
          //   key: "vendor-sku-mgmt2",
          //   route: "/setup/vendor-sku2",
          //   component: <VendorSKUMgmt />
          // },
          {
            name: "Vendor SKU Mgmt",
            key: "vendor-sku-mgmt",
            route: "/setup/sku/vendor-sku",
            component: <VendorSKUList />,
            visible: true,
          },
          {
            name: "Add Vendor SKU",
            key: "add-vendor-sku",
            route: "/setup/sku/vendor-sku/add",
            component: <AddVendorSKU />,
          },
          {
            name: "Edit Vendor SKU",
            key: "edit-vendor-sku",
            route: "/setup/sku/vendor-sku/edit",
            component: <EditVendorSKU />,
            visible: true,
          },
          {
            name: "Add Retail Barcode",
            key: "add-sku-retail-barcode",
            route: "/setup/sku/retail-barcode/add",
            component: <AddSKURetailBarcode />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "SKU Pack Type",
        key: "skuPackType",
        collapse: [
          // {
          //   name: "Pack Type Mgmt",
          //   key: "SKU-Pack-Pack-mgmt",
          //   route: "/setup/sku-pack-type",
          //   component: <SKUPackTypeManagement />
          // },
          {
            name: "Pack Type Mgmt",
            key: "SKU-Pack-Pack-mgmt",
            route: "/setup/sku/pack-type",
            component: <SKUPackTypeList />,
            visible: true,
          },
          {
            name: "Add Pack Type",
            key: "add-sku-pack-type",
            route: "/setup/sku/pack-type/add",
            component: <AddSKUPackType />,
          },
          {
            name: "Edit SKU Pack Type",
            key: "edit-sku-pack-type",
            route: "/setup/sku/pack-type/edit",
            component: <EditSKUPackType />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Shipping Zone",
        key: "shippingZone",
        collapse: [
          {
            name: "Shipping Zone Mgmt",
            key: "shipping-zone-mgmt",
            route: "/setup/shipping-zone",
            component: <ShippingZoneList />,
          },
          {
            name: "Add Shipping Zone",
            key: "add-shipping-zone",
            route: "/setup/shipping-zone/add",
            component: <AddShippingZone />,
          },
          {
            name: "Edit Shipping Zone",
            key: "edit-shipping-zone",
            route: "/setup/shipping-zone/edit",
            component: <EditShippingZone />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Preferred Location",
        key: "preferredLocation",
        collapse: [
          {
            name: "Pref Loc Mgmt",
            key: "preferred-location-management",
            route: "/setup/preferred-location",
            component: <PreferredLocationList />,
          },
          {
            name: "Add Pref Loc",
            key: "add-preferred-location",
            route: "/setup/preferred-location/add",
            component: <NewPreferredLocation />,
          },
          {
            name: "Edit Pref Loc",
            key: "edit-preferred-location",
            route: "/setup/preferred-location/edit",
            component: <EditPreferredLocation />,
            visible: true,
          },
          {
            name: "Upload Pref Loc",
            key: "upload-preferred-location",
            route: "/setup/preferred-location/upload",
            component: <UploadPreferredLocation />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Pick Face Location",
        key: "pickfaceLocation",
        collapse: [
          {
            name: "Pick Face Loc Mgmt",
            key: "pickface-location-management",
            route: "/setup/pickface-location",
            component: <PickFaceLocationList />,
          },
          {
            name: "Add Pick Face Loc",
            key: "add-pickface-location",
            route: "/setup/pickface-location/add",
            component: <NewPickFaceLocation />,
          },
          {
            name: "Remove Pick Face Detail",
            key: "remove-pickface-location",
            route: "/setup/pickface-location/remove",
            component: <RemovePickFaceLocation />,
            visible: true,
          },
          {
            name: "Upload Pick Face Loc",
            key: "upload-pickface-location",
            route: "/setup/pickface-location/upload",
            component: <UploadPickFaceLocation />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Adjustment Reason",
        key: "adjustment-reason",
        collapse: [
          {
            name: "Adjustment Reason Mgmt",
            key: "adjustment-reason-management",
            route: "/setup/adjustment-reason",
            component: <AdjustmentReasonList />,
          },
          {
            name: "Add Adjustment Reason",
            key: "add-adjustment-reason",
            route: "/setup/adjustment-reason/add",
            component: <AddAdjustmentReason />,
          },
          {
            name: "Edit Adjustment Reason",
            key: "edit-adjustment-reason",
            route: "/setup/adjustment-reason/edit",
            component: <EditAdjustmentReason />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Return Code",
        key: "return-code",
        collapse: [
          {
            name: "Return Code Mgmt",
            key: "return-code-management",
            route: "/setup/return-code",
            component: <COReturnCodeList />,
          },
          {
            name: "Add Return Code",
            key: "add-return-code",
            route: "/setup/return-code/add",
            component: <AddCOReturnCode />,
          },
          {
            name: "Edit Return Code",
            key: "edit-return-code",
            route: "/setup/return-code/edit",
            component: <EditCOReturnCode />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Packaging Material",
        key: "packaging-material",
        collapse: [
          {
            name: "Packaging Material Mgmt",
            key: "packaging-material-management",
            route: "/setup/packaging-material",
            component: <PackagingMaterialList />,
          },
          {
            name: "Add Packaging Material",
            key: "add-packaging-material",
            route: "/setup/packaging-material/add",
            component: <AddPackagingMaterial />,
          },
          {
            name: "Edit Packaging Material",
            key: "edit-packaging-material",
            route: "/setup/packaging-material/edit",
            component: <EditPackagingMaterial />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Country",
        key: "country",
        icon: "",
        collapse: [
          {
            name: "Country Mgmt",
            key: "country-management",
            route: "/setup/country",
            component: <CountryList />,
          },
          {
            name: "Add Country",
            key: "add-country",
            route: "/setup/country/add",
            component: <AddCountry />,
          },
          {
            name: "Edit Country",
            key: "edit-country",
            route: "/setup/country/edit",
            component: <EditCountry />,
            visible: true,
          },
        ],
      },
      {
        type: "collapse",
        name: "Division",
        key: "division",
        collapse: [
          {
            name: "Division List",
            key: "division-management",
            route: "/division/list",
            component: <DivisionList />,
          },
          {
            name: "Add Division",
            key: "add-division",
            route: "/division/add",
            component: <AddDivision />,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "User",
    key: "user",
    icon: <Icon fontSize="medium">people</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Team Role",
        key: "team-role",
        collapse: [
          {
            name: "Team Role Mgmt",
            key: "team-role-management",
            route: "/user/team-role",
            component: <TeamRoleList />,
          },
          {
            name: "Add Team Role",
            key: "add-team-role",
            route: "/user/team-role/add",
            component: <NewTeamRole />,
          },
          {
            name: "Edit Team Role",
            key: "edit-team-role",
            route: "/user/team-role/edit",
            component: <EditTeamRole />,
            visible: true,
          },
        ],
      },
    ],
  },
  // {
  //   type: "collapse",
  //   name: "Pages",
  //   key: "pages",
  //   icon: <Icon fontSize="medium">image</Icon>,
  //   collapse: [
  //     {
  //       name: "Profile",
  //       key: "profile",
  //       collapse: [
  //         {
  //           name: "Profile Overview",
  //           key: "profile-overview",
  //           route: "/pages/profile/profile-overview",
  //           component: <ProfileOverview />,
  //         },
  //         {
  //           name: "All Projects",
  //           key: "all-projects",
  //           route: "/pages/profile/all-projects",
  //           component: <AllProjects />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Account",
  //       key: "account",
  //       collapse: [
  //         {
  //           name: "Settings",
  //           key: "settings",
  //           route: "/pages/account/settings",
  //           component: <Settings />,
  //         },
  //         {
  //           name: "Billing",
  //           key: "billing",
  //           route: "/pages/account/billing",
  //           component: <Billing />,
  //         },
  //         {
  //           name: "Invoice",
  //           key: "invoice",
  //           route: "/pages/account/invoice",
  //           component: <Invoice />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Projects",
  //       key: "projects",
  //       collapse: [
  //         {
  //           name: "Timeline",
  //           key: "timeline",
  //           route: "/pages/projects/timeline",
  //           component: <Timeline />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Pricing Page",
  //       key: "pricing-page",
  //       route: "/pages/pricing-page",
  //       component: <PricingPage />,
  //     },
  //     { name: "RTL", key: "rtl", route: "/pages/rtl", component: <RTL /> },
  //     { name: "Widgets", key: "widgets", route: "/pages/widgets", component: <Widgets /> },
  //     { name: "Charts", key: "charts", route: "/pages/charts", component: <Charts /> },
  //     {
  //       name: "Notfications",
  //       key: "notifications",
  //       route: "/pages/notifications",
  //       component: <Notifications />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Applications",
  //   key: "applications",
  //   icon: <Icon fontSize="medium">apps</Icon>,
  //   collapse: [
  //     {
  //       name: "Kanban",
  //       key: "kanban",
  //       route: "/applications/kanban",
  //       component: <Kanban />,
  //     },
  //     {
  //       name: "Wizard",
  //       key: "wizard",
  //       route: "/applications/wizard",
  //       component: <Wizard />,
  //     },
  //     {
  //       name: "Data Tables",
  //       key: "data-tables",
  //       route: "/applications/data-tables",
  //       component: <DataTables />,
  //     },
  //     {
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/applications/calendar",
  //       component: <Calendar />,
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Ecommerce",
  //   key: "ecommerce",
  //   icon: <Icon fontSize="medium">shopping_basket</Icon>,
  //   collapse: [
  //     {
  //       name: "Products",
  //       key: "products",
  //       collapse: [
  //         {
  //           name: "New Product",
  //           key: "new-product",
  //           route: "/ecommerce/products/new-product",
  //           component: <NewProduct />,
  //         },
  //         {
  //           name: "Edit Product",
  //           key: "edit-product",
  //           route: "/ecommerce/products/edit-product",
  //           component: <EditProduct />,
  //         },
  //         {
  //           name: "Product Page",
  //           key: "product-page",
  //           route: "/ecommerce/products/product-page",
  //           component: <ProductPage />,
  //         },
  //       ],
  //     },
  //     {
  //       name: "Orders",
  //       key: "orders",
  //       collapse: [
  //         {
  //           name: "Order List",
  //           key: "order-list",
  //           route: "/ecommerce/orders/order-list",
  //           component: <OrderList />,
  //         },
  //         {
  //           name: "Order Details",
  //           key: "order-details",
  //           route: "/ecommerce/orders/order-details",
  //           component: <OrderDetails />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  /*{
    type: "collapse",
    name: "Authentication",
    key: "authentication",
    icon: <Icon fontSize="medium">content_paste</Icon>,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Basic",
            key: "basic",
            route: "/login",
            component: <SignInBasic />,
          },
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/sign-in/cover",
            component: <SignInCover />,
          },
          {
            name: "Illustration",
            key: "illustration",
            route: "/authentication/sign-in/illustration",
            component: <SignInIllustration />,
          },
        ],
      },
      {
        name: "Sign Up",
        key: "sign-up",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/sign-up/cover",
            component: <SignUpCover />,
          },
        ],
      },
      {
        name: "Reset Password",
        key: "reset-password",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/reset-password/cover",
            component: <ResetCover />,
          },
        ],
      },
    ],
  },*/
  // { type: "divider", key: "divider-1" },
  // { type: "title", title: "Docs", key: "title-docs" },
  // {
  //   type: "collapse",
  //   name: "Basic",
  //   key: "basic",
  //   icon: <Icon fontSize="medium">upcoming</Icon>,
  //   collapse: [
  //     {
  //       name: "Getting Started",
  //       key: "getting-started",
  //       collapse: [
  //         {
  //           name: "Overview",
  //           key: "overview",
  //           href: "https://www.creative-tim.com/learning-lab/react/overview/material-dashboard/",
  //         },
  //         {
  //           name: "License",
  //           key: "license",
  //           href: "https://www.creative-tim.com/learning-lab/react/license/material-dashboard/",
  //         },
  //         {
  //           name: "Quick Start",
  //           key: "quick-start",
  //           href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-dashboard/",
  //         },
  //         {
  //           name: "Build Tools",
  //           key: "build-tools",
  //           href: "https://www.creative-tim.com/learning-lab/react/build-tools/material-dashboard/",
  //         },
  //       ],
  //     },
  //     {
  //       name: "Foundation",
  //       key: "foundation",
  //       collapse: [
  //         {
  //           name: "Colors",
  //           key: "colors",
  //           href: "https://www.creative-tim.com/learning-lab/react/colors/material-dashboard/",
  //         },
  //         {
  //           name: "Grid",
  //           key: "grid",
  //           href: "https://www.creative-tim.com/learning-lab/react/grid/material-dashboard/",
  //         },
  //         {
  //           name: "Typography",
  //           key: "base-typography",
  //           href: "https://www.creative-tim.com/learning-lab/react/base-typography/material-dashboard/",
  //         },
  //         {
  //           name: "Borders",
  //           key: "borders",
  //           href: "https://www.creative-tim.com/learning-lab/react/borders/material-dashboard/",
  //         },
  //         {
  //           name: "Box Shadows",
  //           key: "box-shadows",
  //           href: "https://www.creative-tim.com/learning-lab/react/box-shadows/material-dashboard/",
  //         },
  //         {
  //           name: "Functions",
  //           key: "functions",
  //           href: "https://www.creative-tim.com/learning-lab/react/functions/material-dashboard/",
  //         },
  //         {
  //           name: "Routing System",
  //           key: "routing-system",
  //           href: "https://www.creative-tim.com/learning-lab/react/routing-system/material-dashboard/",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: "collapse",
  //   name: "Components",
  //   key: "components",
  //   icon: <Icon fontSize="medium">view_in_ar</Icon>,
  //   collapse: [
  //     {
  //       name: "Alerts",
  //       key: "alerts",
  //       href: "https://www.creative-tim.com/learning-lab/react/alerts/material-dashboard/",
  //     },
  //     {
  //       name: "Avatar",
  //       key: "avatar",
  //       href: "https://www.creative-tim.com/learning-lab/react/avatar/material-dashboard/",
  //     },
  //     {
  //       name: "Badge",
  //       key: "badge",
  //       href: "https://www.creative-tim.com/learning-lab/react/badge/material-dashboard/",
  //     },
  //     {
  //       name: "Badge Dot",
  //       key: "badge-dot",
  //       href: "https://www.creative-tim.com/learning-lab/react/badge-dot/material-dashboard/",
  //     },
  //     {
  //       name: "Box",
  //       key: "box",
  //       href: "https://www.creative-tim.com/learning-lab/react/box/material-dashboard/",
  //     },
  //     {
  //       name: "Buttons",
  //       key: "buttons",
  //       href: "https://www.creative-tim.com/learning-lab/react/buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Date Picker",
  //       key: "date-picker",
  //       href: "https://www.creative-tim.com/learning-lab/react/datepicker/material-dashboard/",
  //     },
  //     {
  //       name: "Dropzone",
  //       key: "dropzone",
  //       href: "https://www.creative-tim.com/learning-lab/react/dropzone/material-dashboard/",
  //     },
  //     {
  //       name: "Editor",
  //       key: "editor",
  //       href: "https://www.creative-tim.com/learning-lab/react/quill/material-dashboard/",
  //     },
  //     {
  //       name: "Input",
  //       key: "input",
  //       href: "https://www.creative-tim.com/learning-lab/react/input/material-dashboard/",
  //     },
  //     {
  //       name: "Pagination",
  //       key: "pagination",
  //       href: "https://www.creative-tim.com/learning-lab/react/pagination/material-dashboard/",
  //     },
  //     {
  //       name: "Progress",
  //       key: "progress",
  //       href: "https://www.creative-tim.com/learning-lab/react/progress/material-dashboard/",
  //     },
  //     {
  //       name: "Snackbar",
  //       key: "snackbar",
  //       href: "https://www.creative-tim.com/learning-lab/react/snackbar/material-dashboard/",
  //     },
  //     {
  //       name: "Social Button",
  //       key: "social-button",
  //       href: "https://www.creative-tim.com/learning-lab/react/social-buttons/material-dashboard/",
  //     },
  //     {
  //       name: "Typography",
  //       key: "typography",
  //       href: "https://www.creative-tim.com/learning-lab/react/typography/material-dashboard/",
  //     },
  //   ],
  // },
];

export default routes;
